// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__rBIGs","container":"styles_container__bH2F8","title":"styles_title__1B6Oz","wrapper":"styles_wrapper__2lz_4","answer":"styles_answer__3BMOj"};